(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bontex-tier-buy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.bontex-tier-buy').forEach((root) => {
    const moqMin = Number(root.dataset.moqMin) || 50;
    const notice = root.querySelector('[data-moq-notice]');
    const noticeText = notice?.querySelector('[data-moq-notice-text]')?.textContent?.trim() || '';
    const liveRegion = root.querySelector('[ref="liveRegion"]');
    const form = root.querySelector('form');
    const qtyInput = form?.querySelector('[name="quantity"]');
    const variantIdInput = form?.querySelector('[name="id"]');
    const productFormComponent = root.querySelector('product-form-component');
    const productId = root.dataset.productId || '';
    const productUrl = productFormComponent?.dataset.productUrl || '';
    let fetchController = null;

    const showMoqNotice = () => {
      if (notice) notice.hidden = false;
      if (liveRegion) liveRegion.textContent = noticeText;
    };

    const hideMoqNotice = () => {
      if (notice) notice.hidden = true;
    };

    if (form) {
      form.addEventListener(
        'invalid',
        (event) => {
          if (event.target === qtyInput) {
            event.preventDefault();
            showMoqNotice();
          }
        },
        true
      );

      form.addEventListener('submit', (event) => {
        const qty = Number(qtyInput?.value) || 0;
        if (qty >= moqMin) {
          hideMoqNotice();
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        showMoqNotice();
      });
    }

    const buttons = root.querySelectorAll('.bontex-tier-buy__tier');
    if (!buttons.length) return;

    const summaryQty = root.querySelector('.bontex-tier-buy__summary-qty');
    const summaryPrice = root.querySelector('.bontex-tier-buy__summary-price');
    const priceContainer =
      document.querySelector('.product-details [ref="priceContainer"]') ||
      document.querySelector('.product-details');
    const priceTarget = priceContainer ? priceContainer.querySelector('.price') : null;
    const stickyPriceTarget = document.querySelector('sticky-add-to-cart .sticky-add-to-cart__price .price');
    const stickyBar = document.querySelector('sticky-add-to-cart');
    const submitButton = root.querySelector('.bontex-tier-buy__submit');

    const updatePriceDisplay = (button) => {
      const formatted = button.dataset.priceFormatted;
      if (priceTarget && formatted) priceTarget.textContent = formatted;
      if (stickyPriceTarget && formatted) stickyPriceTarget.textContent = formatted;
    };

    const dispatchVariantSelect = (button) => {
      const variantId = button.dataset.variantId;
      if (!variantId || !productUrl || !productId) return;

      const url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      const currentPreview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (currentPreview) url.searchParams.set('preview_theme_id', currentPreview);

      let resolvePromise;
      let rejectPromise;
      const promise = new Promise((resolve, reject) => {
        resolvePromise = resolve;
        rejectPromise = reject;
      });

      const event = new CustomEvent('shopify:product:select', { bubbles: true, detail: { variantId } });
      event.promise = promise;
      root.dispatchEvent(event);

      if (fetchController) fetchController.abort();
      fetchController = new AbortController();

      fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: fetchController.signal,
      })
        .then((response) => response.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          resolvePromise({
            variant: { id: variantId },
            detail: {
              html,
              productId,
              newProduct: false,
              resource: { id: variantId, available: button.dataset.available === 'true' },
            },
          });
        })
        .catch((error) => {
          rejectPromise(error);
        });
    };

    const applyTier = (button, options = {}) => {
      const qty = button.dataset.qty;
      const variantId = button.dataset.variantId;

      buttons.forEach((b) => {
        const active = b === button;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (qtyInput) qtyInput.value = qty;
      if (variantIdInput && variantId) variantIdInput.value = variantId;
      if (summaryQty) summaryQty.textContent = qty;
      if (summaryPrice) summaryPrice.textContent = button.dataset.priceFormatted;
      if (submitButton) submitButton.disabled = button.dataset.available !== 'true';
      updatePriceDisplay(button);
      hideMoqNotice();

      document.dispatchEvent(new CustomEvent('quantity-selector:update', { detail: { quantity: Number(qty) } }));
      if (stickyBar) stickyBar.setAttribute('data-initial-quantity', qty);

      if (!options.silent) dispatchVariantSelect(button);
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => applyTier(button));
    });

    if (buttons[0]) applyTier(buttons[0], { silent: true });
  });
  } catch(e) { console.error(e); }
})();

})();
